



















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';
import commonService from '@/services/common-services';

@Component
export default class ListQuotation extends Vue {
    @Prop({ default: () => [] })
    private items!: any[];

    private chinaStoreMap: { [key: number]: string } = {};
    private vnStoreMap: { [key: number]: string } = {};

    mounted() {
        this.fetchWarehouseMaps();
    }

    private async fetchWarehouseMaps() {
        try {
            const [cnRes, vnRes]: any[] = await Promise.all([
                commonService.getChinaStore().catch(() => null),
                commonService.getWarehouse().catch(() => null)
            ]);

            if (cnRes && cnRes.data) {
                const list = cnRes.data.data || cnRes.data;
                if (Array.isArray(list)) {
                    const map: { [key: number]: string } = {};
                    list.forEach((s: any) => {
                        if (s.ID && s.Name) {
                            map[Number(s.ID)] = s.Name;
                        }
                    });
                    this.chinaStoreMap = map;
                }
            }

            if (vnRes && vnRes.data) {
                const list = vnRes.data.data || vnRes.data;
                if (Array.isArray(list)) {
                    const map: { [key: number]: string } = {};
                    list.forEach((s: any) => {
                        if (s.ID && s.Name) {
                            map[Number(s.ID)] = s.Name;
                        }
                    });
                    this.vnStoreMap = map;
                }
            }
        } catch (e) {
            // ignore
        }
    }

    private getWarehouseCn(q: any): string {
        const cond = String(q.declaration_condition || '').toUpperCase().trim();
        if (['LCL', 'FCL'].includes(cond)) {
            return q.port_departure || 'Cảng TQ';
        }
        const whCn = String(q.warehouse_cn || '').trim();
        if (whCn && !/^\d+$/.test(whCn) && !whCn.startsWith('Kho #') && whCn.toLowerCase() !== 'kho tq') {
            return whCn;
        }
        const storeId = q.legacy_china_store_id || q.china_store_id || (whCn && /^\d+$/.test(whCn) ? parseInt(whCn, 10) : null);
        if (storeId && this.chinaStoreMap[Number(storeId)]) {
            return this.chinaStoreMap[Number(storeId)];
        }
        if (whCn && !/^\d+$/.test(whCn) && whCn.toLowerCase() !== 'kho tq') {
            return whCn;
        }
        if (storeId) {
            return `Kho #${storeId}`;
        }
        if (['ECL', 'EFC'].includes(cond)) {
            return 'Chính ngạch đường biển có VAT';
        }
        return 'Chính ngạch đường bộ (Có VAT)';
    }

    private getWarehouseVn(q: any): string {
        const cond = String(q.declaration_condition || '').toUpperCase().trim();
        if (['LCL', 'FCL'].includes(cond)) {
            return q.port_arrival || 'Cảng VN';
        }
        const whVn = String(q.warehouse_vn || '').trim();
        if (whVn && !/^\d+$/.test(whVn) && !whVn.startsWith('Kho #') && !whVn.toLowerCase().includes('chính ngạch')) {
            return whVn;
        }
        const storeId = q.legacy_receive_place_id || q.receive_place_id || (whVn && /^\d+$/.test(whVn) ? parseInt(whVn, 10) : null);
        if (storeId && this.vnStoreMap[Number(storeId)]) {
            return this.vnStoreMap[Number(storeId)];
        }
        if (whVn && !/^\d+$/.test(whVn)) {
            return whVn;
        }
        if (storeId && storeId !== 1) {
            return `Kho #${storeId}`;
        }
        return 'Kho Hà Nội';
    }

    private getWarehouseRoute(q: any): string {
        return `${this.getWarehouseCn(q)} → ${this.getWarehouseVn(q)}`;
    }

    private viewDetail(id: number) {
        this.$router.push({
            name: 'quotation-detail',
            params: { id: id.toString() }
        }).catch(() => {});
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private getStatusName(status: string): string {
        switch (status) {
            case 'draft': return 'Nháp';
            case 'cho-duyet':
            case 'cho-bao-gia': return 'Chờ duyệt';
            case 'da-gui': return 'Đã gửi KH';
            case 'kh-da-duyet': return 'KH đã duyệt';
            case 'xnk-da-duyet':
            case 'da-duyet': return 'XNK đã duyệt';
            case 'cho-xep-xe': return 'Chờ xếp xe';
            case 'dang-van-chuyen': return 'Đang vận chuyển';
            case 'da-nhap-kho-nhan': return 'Nhập kho VN';
            case 'hoan-thanh': return 'Hoàn thành';
            case 'huy': return 'Đã hủy';
            default: return status || '—';
        }
    }

    private getStatusColor(status: string): string {
        switch (status) {
            case 'draft':
                return '#7a8498';
            case 'cho-duyet':
            case 'cho-bao-gia':
                return '#f39c12';
            case 'da-gui':
                return '#2bbae4';
            case 'kh-da-duyet':
                return '#27ae60';
            case 'xnk-da-duyet':
            case 'da-duyet':
                return '#2980b9';
            case 'cho-xep-xe':
                return '#e67e22';
            case 'dang-van-chuyen':
            case 'da-xep-xe':
            case 'dang-ve-kho-nhan':
                return '#f7819f';
            case 'da-nhap-kho-nhan':
                return '#00bcd4';
            case 'hoan-thanh':
                return '#7a8498';
            case 'huy':
                return 'black';
            default:
                return '#7a8498';
        }
    }
}
